import axios from "axios";

export default
  id =>
    axios
      .delete(
        `/v1/announcements/${id}`
      );
